<template>
  <iframe
    :src="`https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(url)}&show_text=false&width=360`"
    style="width: 100%; height: 100%; border: 0;"
    allowfullscreen
  ></iframe>
</template>

<script>
export default {
  name: 'FacebookReel',

  props: {
    url: { type: String, required: true }
  }
};
</script>

<style scoped>
/* Your styles here */
</style>
